import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { IRootState } from '../reducers';
import AppRoutes from '../Routes';
import Sidebar from '../components/Sidebar/Sidebar';
import ErrorBoundary from '../shared/error/error-boundary';
import { getCurrentUser, getSession, logout } from '../reducers/authentication';
import { getVersionInfo } from '../reducers/config';
import { PUBLIC_URL } from '../config/constants';

export interface IAppProps extends StateProps, DispatchProps {}

export const App: React.FC<IAppProps> = (props) => {
    useEffect(() => {
        props.getSession();
        // props.getVersionInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /*useEffect(() => {
        if (props.isAuthenticated) {
            props.getCurrentUser();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isAuthenticated]);*/

    return (
        <Router basename={PUBLIC_URL || '/'}>
            <ErrorBoundary>
                <div className="main-container">
                    <AppRoutes />

                    {props.isAuthenticated && <Sidebar user={props.user} onLogout={props.logout} />}
                </div>
            </ErrorBoundary>
        </Router>
    );
};

const mapStateToProps = ({ auth }: IRootState) => ({
    isAuthenticated: auth.isAuthenticated,
    user: auth.user,
});

const mapDispatchToProps = {
    getSession,
    getCurrentUser,
    getVersionInfo,
    logout,
};

// eslint-disable-next-line no-undef
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

// @ts-ignore
export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(App);
